import { Component, OnInit } from '@angular/core';
import { Searchgeneral } from 'src/app/model/searchgeneral.model';
import { Question } from 'src/app/model/question.model';
import { UserService } from 'src/app/services/user/user.service';
import { NgForm } from '@angular/forms';
import { RoleService } from 'src/app/services/role/role.service';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormControl, FormArray, Validators, FormBuilder } from '@angular/forms';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import 'ag-grid-community';
import { DatePipe } from '@angular/common';
import { ButtonRendererComponent } from 'src/app/button-renderer.component';

@Component({
  selector: 'app-addpurchaselines',
  templateUrl: './prescreening.component.html',
  styleUrls: ['./prescreening.component.css'],
  providers: [DatePipe]
})
export class PrescreeningComponent implements OnInit {

  correctAns: string;
  questionDataAny: any;
  searchGeneral: Searchgeneral;
  question: Question;
  projectDetails: any;
  data: any;
  selectedOption = [];
  surveyForm: FormGroup;
  showDataBool: boolean = false;
  isListLoading: boolean = false;
  vendorSelectBool: boolean = false;
  addQuestionBool: boolean = false;
  rowData: any;
  ansGridBool: boolean = false;
  rowDataForAns: any;
  pagination = true;
  paginationPageSize = 5;
  private gridApi;
  private gridColumnApi;
  rightAns: any;
  ansString: string;
  vendName: string;
  singleMultipleBool: boolean = false;
  allRowDataForAns: any;
  columnDefs = [
    //{headerName: '', field: '', width: 50, headerCheckboxSelection: true, checkboxSelection: true, minWidth:40},
    { headerName: "#", field: "index", maxWidth: 40, valueGetter: "node.rowIndex + 1" },
    // { headerName: "Vendor Name", field: "vName", filter: true, sortable: true, resizable: true },
    { headerName: "Question Title", field: "question", resizable: true },
    { headerName: "Question Type", field: "questionType", resizable: true, maxWidth: 130 },
    { headerName: "No. Of Options", field: "totalNoOfOptions", resizable: true, maxWidth: 120 },
    { headerName: "Options", field: "options", resizable: true },
    { headerName: "Correct Answer", field: "correctOption", resizable: true },
    {
      headerName: 'Delete',
      cellRenderer: 'buttonRenderer',
      cellRendererParams: {
        onClick: this.deleteProject.bind(this),
        label: 'Delete'
      },
      maxWidth: 100,
    },

  ];
  columnDefsForAns = [
    //{headerName: '', field: '', headerCheckboxSelection: true, checkboxSelection: true, width:10},
    { headerName: "#", field: "index", valueGetter: "node.rowIndex + 1", maxWidth: 40 },
    { headerName: "Options", field: "options", resizable: true, editable: true },
    { headerName: 'Correct Options', field: 'correctoptions', checkboxSelection: true, maxWidth: 117 },

  ];
  autoGroupColumnDef = {
    headerName: 'Select',
    field: 'select',
    minWidth: 250,
    cellRenderer: 'agGroupCellRenderer',
    cellRendererParams: { checkbox: true },
  };
  defaultColDef = {
    flex: 1,
    minWidth: 100,
  };
  rowSelection = 'single';
  frameworkComponents: any;
  constructor(private userService: UserService, private datePipe: DatePipe, private roleservice: RoleService, private toastr: ToastrService) {
    this.frameworkComponents = {
      buttonRenderer: ButtonRendererComponent,
    }
  }

  ngOnInit() {
    this.searchGeneral = new Searchgeneral();
    this.question = new Question();
    this.ansGridBool = false;
  }

  getVendorList(projectId) {
    debugger;
    this.userService.getProjectSpecificCountryList(projectId).subscribe(
      (data) => {
        this.data = data;
        console.log("vendorData" + this.data);
      }
    )
  }

  vendorSelected(event: any) {
    debugger;
    // console.log(event.target.value);
    this.vendorSelectBool = true
    this.ansGridBool = false;
    this.vendName = event.target.value;
    this.roleservice.GetQuestions(this.searchGeneral.projectid, this.vendName).subscribe(
      (data: any) => {
        console.log("data", data);
        for (var i = 0; i < data.length; i++) {
          if (data[i].questionType == "1") {
            data[i].questionType = "Single Choice";
          }
          else if (data[i].questionType == "2") {
            data[i].questionType = "Multi Choice";
          }
          else if (data[i].questionType == "4") {                 
            data[i].questionType = "Multi Choice";   // for multi-single
          }

          else if (data[i].questionType == "3") {
            data[i].questionType = "Text";
          }
        }
        this.rowData = data;
        //console.log(this.rowData);
      }
    )
    this.resetForm();
  }

  SubmitSearchListForm(form: NgForm) {
    debugger;
    this.isListLoading = true;
    this.vendorSelectBool = false;
    this.addQuestionBool = false;
    this.roleservice.SearchProjectDetails(this.searchGeneral).subscribe(
      (data: any) => {
        this.isListLoading = false;
        this.projectDetails = data;
        this.getVendorList(this.searchGeneral.projectid);
        if (this.projectDetails.length === 0) {
          this.showDataBool = false;
          this.toastr.error("No items found", '', { progressBar: true });
        }
        else {
          this.showDataBool = true;
        }
        console.log(this.projectDetails);
      }
    )
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }
  onGridReadyForAns(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  AddQuestion() {
    this.addQuestionBool = true;
  }
  OptionSelected(event) {
    //console.log(event.target.value);
    if  (event.target.value == 1 || event.target.value == 2 || event.target.value == 4 ){
      this.singleMultipleBool = true;
      if (event.target.value == 1) {
        this.rowSelection = 'single';
      }

      else if (event.target.value == 2) {
        this.rowSelection = 'multiple';
      }
      else if (event.target.value == 4){
        this.rowSelection = 'multiple'      // for multi-single      
      }

    }
    else {
      this.singleMultipleBool = false;
      this.ansGridBool = false;
    }
  }
  SubmitQuestion(form: NgForm) {
    debugger;
    console.log(form.value)
    this.ansString = "";
    this.correctAns = "";
    this.ansGridBool = false;
    form.value.projectId = this.searchGeneral.projectid;
    form.value.vendID = this.vendName;
    if (form.value.questiontype == "1" || form.value.questiontype == "2" || form.value.questiontype == "4")  {
      this.getAllRows();
      this.getRightAns();
      // console.log("right ans",this.rightAns);
      // console.log("row Data",this.allRowDataForAns);
      for (var i = 0; i < this.allRowDataForAns.length; i++) {
        this.ansString += this.allRowDataForAns[i].options + "|";
      }
      if (this.ansString != "") {
        this.ansString = this.ansString.substring(0, this.ansString.length - 1);
      }
      for (var i = 0; i < this.rightAns.length; i++) {
        this.correctAns += this.rightAns[i].options + "|";
      }
      if (this.correctAns != "") {
        this.correctAns = this.correctAns.substring(0, this.correctAns.length - 1);
      }
    }
    form.value.ansString = this.ansString;
    form.value.correctAns = this.correctAns;
    this.userService.addQuestion(form.value)
      .subscribe((data: any) => {
        debugger;
        if (data != null) {
          this.roleservice.GetQuestions(this.searchGeneral.projectid, this.vendName).subscribe(
            (data: any) => {
              console.log("data", data);
              for (var i = 0; i < data.length; i++) {
                if (data[i].questionType == "1") {
                  data[i].questionType = "Single Choice";
                }
                else if (data[i].questionType == "2") {
                  data[i].questionType = "Multi Choice";
                }
                else if (data[i].questionType == "4") {
                  data[i].questionType = "Multi-single Choice";  //for multi-single       
                }
                
                else if (data[i].questionType == "3") {
                  data[i].questionType = "Text";
                }
              }
              this.rowData = data;
              //console.log(this.rowData);
            }
          )
        }
        else {

        }
      });
    // if(form.value.questiontype == "1" || form.value.questiontype == "2")
    // {
    //   this.getAllRows();
    //   this.getRightAns();
    //   // console.log("right ans",this.rightAns);
    //   // console.log("row Data",this.allRowDataForAns);
    //   for(var i=0;i<this.allRowDataForAns.length;i++)
    //   {
    //     this.ansString += this.allRowDataForAns[i].options + ",";
    //   }
    //   if(this.ansString != "")
    //   {
    //     this.ansString = this.ansString.substring(0, this.ansString.length - 1);
    //   }
    //   for(var i=0;i<this.rightAns.length;i++)
    //   {
    //     this.correctAns += this.rightAns[i].options + ",";
    //   }
    //   if(this.correctAns != "")
    //   {
    //     this.correctAns = this.correctAns.substring(0, this.correctAns.length - 1);
    //   }
    // }
    // this.userService.addAnswers(this.ansString,this.searchGeneral.projectid,this.vendName,this.correctAns)
    // .subscribe((data : any) => {
    //     if(data == true)
    //     {

    //     }
    //     else
    //     {

    //     }
    // });


    // this.roleservice.GetQuestions(this.searchGeneral.projectid,this.vendName).subscribe(
    //   (data:any) => {
    //     console.log("data",data);
    //     for(var i=0;i<data.length;i++)
    //     {
    //       if(data[i].questionType == "1")
    //       {
    //          data[i].questionType = "Single Choice";
    //       }
    //       else if(data[i].questionType == "2")
    //       {
    //         data[i].questionType = "Multi Choice";
    //       }
    //       else if(data[i].questionType == "3")
    //       {
    //         data[i].questionType = "Text";
    //       }
    //     }
    //     this.rowData=data;
    //     //console.log(this.rowData);
    //   }
    // )

    this.resetForm();

  }
  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();
    this.singleMultipleBool = false;
    this.question = new Question();
  }
  NoOfOptionsSelected(event) {
    debugger;
    this.ansGridBool = true;
    switch (event.target.value) {
      case "2":
        this.rowDataForAns=[
          {options:''},
          {options:''},
        ];
          break;
      case "3":
        this.rowDataForAns = [
          { options: '' },
          { options: '' },
          { options: '' },
        ];
        break;
      case "4":
        this.rowDataForAns = [
          { options: '' },
          { options: '' },
          { options: '' },
          { options: '' },
        ];
        break;
      case "5":
        this.rowDataForAns = [
          { options: '' },
          { options: '' },
          { options: '' },
          { options: '' },
          { options: '' },
        ];
        break;
      case "6":
        this.rowDataForAns = [
          { options: '' },
          { options: '' },
          { options: '' },
          { options: '' },
          { options: '' },
          { options: '' },
        ];
        break;
      case "7":
        this.rowDataForAns = [
          { options: '' },
          { options: '' },
          { options: '' },
          { options: '' },
          { options: '' },
          { options: '' },
          { options: '' },
        ];
        break;
      case "8":
        this.rowDataForAns = [
          { options: '' },
          { options: '' },
          { options: '' },
          { options: '' },
          { options: '' },
          { options: '' },
          { options: '' },
          { options: '' },
        ];
        break;
      case "9":
        this.rowDataForAns = [
          { options: '' },
          { options: '' },
          { options: '' },
          { options: '' },
          { options: '' },
          { options: '' },
          { options: '' },
          { options: '' },
          { options: '' },
        ];
        break;
      case "10":
        this.rowDataForAns = [
          { options: '' },
          { options: '' },
          { options: '' },
          { options: '' },
          { options: '' },
          { options: '' },
          { options: '' },
          { options: '' },
          { options: '' },
          { options: '' },
        ];
        break;

      default:
        break;
    }
  }
  getAllRows() {
    this.allRowDataForAns = [];
    this.gridApi.forEachNode(node => this.allRowDataForAns.push(node.data));
    return this.allRowDataForAns;
  }
  getRightAns() {
    debugger;
    this.rightAns = [];
    let selectedNode = this.gridApi.getSelectedNodes();
    for (var i = 0; i < selectedNode.length; i++) {
      this.rightAns.push(selectedNode[i].data);
    }
    return this.rightAns;
  }

  deleteProject(params) {
    debugger;
    this.userService.deleteQuestion(params.data.id).subscribe(
      (data) => {
        if (data == true) {
          this.roleservice.GetQuestions(this.searchGeneral.projectid, this.vendName).subscribe(
            (data: any) => {
              for (var i = 0; i < data.length; i++) {
                if (data[i].questionType == "1") {
                  data[i].questionType = "Single Choice";
                }
                else if (data[i].questionType == "2") {
                  data[i].questionType = "Multi Choice";
                }
                else if (data[i].questionType == "3") {
                  data[i].questionType = "Text";
                }
              }
              this.rowData = data;
              //console.log(this.rowData);
            }
          )
        }
        else {

        }
      });
  }


}
